import React, { HtmlHTMLAttributes } from 'react'
import styles from './hr.module.scss'
import cx from 'classnames'

const HR: React.FC<HtmlHTMLAttributes<HTMLHRElement>> = ({ className, ...props }) => (
  <hr {...props} className={cx(styles.hr, className)} />
)

export default HR
